
import FormInput2 from '@/components/forms/FormInput2.vue'
import { Component, Emit, Prop, Vue } from 'vue-property-decorator'

@Component({
  name: 'AdmitFields',
  components: {
    FormInput2,
  },
})
export default class extends Vue {
  @Prop({
    default: () => ({
      first: '',
      last: '',
      email: '',
    }),
  })
  value: MembershipAdmitDetails

  @Prop({ required: true })
  emailRequired: MembershipAdmitDetailsConfig

  @Emit('input')
  emit(): MembershipAdmitDetails {
    return { ...this.value }
  }

  get showEmailInput() {
    return this.emailRequired !== 'no'
  }

  get isEmailRequired() {
    return this.emailRequired === 'yes'
  }
}
